import React, { ReactNode } from "react";
import Tag from "../../../../../generic/tag";
import "../../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsMob.scss";
import { INcd } from "../../../../../types/components/orderBook/obTypes";
import { HObGroupBy } from "../../../../../service/orderBook/obGrpByHelper";
import { ChipColorKeyComb, ChipStatusComb } from "../../../obConstants";
import { toINR } from "../../../../../service/numberFormat";
import bStrg from "../../../../../service/storageHelper";
import { AddRemClass } from "../../../../../helper/addRemoveClsOfTgt";

export interface IObNcdMobProps {
	data: Array<INcd>;
	isHistory: boolean;
	noDataNode: ReactNode;
}

const ObNcdMob: React.FC<IObNcdMobProps> = (props) => {
	// wherever initial data needs to be sent, send initialData
	// initial data is array of array for supporting grouping
	const initialData = [props.data],
		todayDate = bStrg("todayDate") || new Date();
	let [tableData, setTableData] = React.useState(initialData);
	let ncdData: Array<{ [x: string]: Array<INcd> }> | null = null,
		todaysNcds: Array<Array<{}>> | null = null;

	React.useEffect(() => {
		setTableData([props.data]);
	}, [props.data]);

	if (props.data) {
		//group data based on biddingEndDate
		let results = tableData.map((group: Array<any>) =>
			group.reduce(
				(arr: any, d: INcd) => {
					if (new Date(d.tmStm).setHours(0, 0, 0).valueOf() === new Date(todayDate).setHours(0, 0, 0).valueOf()) {
						arr[0] = [...arr[0], d];
					} else {
						arr[1] = [...arr[1], d];
					}
					return arr;
				},
				[[], []]
			)
		);
		if (!props.isHistory) {
			todaysNcds = results[0][0].length > 0 ? [results[0][0]] : null;
		} else {
			ncdData = results[0][1].length > 0 ? [HObGroupBy(results[0][1], "tmStm", " ")] : null;
		}
	}

	function ncdExpRw(data: INcd, groupIndex: number, index: number) {
		return (
			<div className={"dockDown ncd_dockDown" + groupIndex + "" + index}>
				<div className="dropdown_overlay" onClick={() => AddRemClass(false, ".ncd_dockDown" + groupIndex + "" + index, "expand")} />

				<div className="ncd_mob_details">
					<div className="taRight">
						<button
							className="edBtn ncdDetailCls"
							onClick={() => AddRemClass(false, ".ncd_dockDown" + groupIndex + "" + index, "expand")}
						>
							<i className="edel-icon-close"></i>
						</button>
					</div>
					<div>
						<div className="f0 tag_sym">
							<Tag value="BUY" shape="mini_circle" color="green" height="60px" width="60px" />
							<div className="sym">{data.sym}</div>
						</div>
						<div className="date_sts">
							<label className="date"> {data.tmStm}</label>

							<div className="sts">
								<Tag value={ChipStatusComb[data.sts.toLowerCase()]} shape="chip" color={ChipColorKeyComb[data.sts.toLowerCase()]} />
							</div>
						</div>
					</div>
					<div className="botm_sec">
						<ul className="dtl_list ib">
							<li>
								<div className="dtl_row">
									<span className="txt">Issue Type</span>
									<span className="val">{data.issTyp}</span>
								</div>
								<div className="dtl_row">
									<span className="txt">Application No.</span>
									<span className="val">{data.apNo}</span>
								</div>
								<div className="dtl_row">
									<span className="txt">Order No.</span>
									<span className="val">{data.noID}</span>
								</div>
								<div className="dtl_row">
									<span className="txt">Bid</span>
									<span className="val">{data.bNo}</span>
								</div>
								<div className="dtl_row">
									<span className="txt">Remarks</span>
									<span className={"val " + (data.sts.toLowerCase().indexOf("rejected") >= 0 ? "rejected" : "")}>
										{data.msg ? data.msg : "--"}
									</span>
								</div>
							</li>
						</ul>
						{/* <div className="btn_con ib">
							<a href="text" className="cncl_btn btn">
								Cancel Order
							</a>
							<a href="text" className="modfy_btn btn">
								Modify Order
							</a>
						</div> */}
					</div>
				</div>
			</div>
		);
	}

	function ncdRw(data: INcd, groupIndex: number, index: number) {
		return (
			<React.Fragment key={index}>
				<div
					className="ncd_mob new_offers_mob_con"
					key={index}
					onClick={() => AddRemClass(true, ".ncd_dockDown" + groupIndex + "" + index, "expand")}
				>
					<div className="tag">
						<Tag value="B" shape="mini_circle" color="green" height="30px" width="30px" />
					</div>
					<div className="new_offers_data">
						<div className="date"> {data.tmStm.split(" ")[1].toLowerCase().trim()}</div>
						<div className="comp_con">
							<div className="sym">{data.sym}</div>
							<div className="sts">
								<Tag value={ChipStatusComb[data.sts.toLowerCase()]} color={ChipColorKeyComb[data.sts]} />
							</div>
						</div>
						<div className="new_offers_values">
							<div className="prod_value">
								<span className="prod_type pd-r10">{data.issTyp}</span>
								<span>{data.qty}</span> Qty.
							</div>
							<div className="amt">₹{toINR(data.amt, 2)}</div>
						</div>
					</div>
				</div>
				{ncdExpRw(data, groupIndex, index)}
			</React.Fragment>
		);
	}
	return (
		<>
			<div className="ncd_table_mob">
				{
					props.isHistory
						? ncdData !== null &&
						  ncdData.map((group, groupIndex) =>
								Object.keys(group).map((date, GIindex) => {
									return (
										<React.Fragment key={GIindex}>
											{/* if history componenet need to show*/}

											<ul className="eq_hist_date hist_date" key={"dtGp" + GIindex}>
												<li>{date.split(",")[0]}</li>
											</ul>
											<ul key={"dtUlDet" + GIindex}>
												{group[date].map((row: any, index: number) => ncdRw(row, GIindex, index))}
											</ul>
										</React.Fragment>
									);
								})
						  )
						: todaysNcds !== null &&
						  todaysNcds.map((group: any, groupIndex: number) =>
								// Object.keys(group).map((grp: any, index) =>
								{
									return (
										<React.Fragment key={groupIndex}>
											{group.length > 0 && (
												<ul key={groupIndex} className={"blockDivider child" + groupIndex}>
													{group.map((row: any, index: number) => (
														<React.Fragment key={index}>{ncdRw(row, groupIndex, index)}</React.Fragment>
													))}
												</ul>
											)}
										</React.Fragment>
									);
								}
						  )
					// )
				}
			</div>

			{((ncdData === null && props.isHistory) || (todaysNcds === null && !props.isHistory)) && props.noDataNode}
		</>
	);
};

export default ObNcdMob;
